import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { CELL_INFO } from "../CellToolbox";
import { t } from "../../../i18n";
import ImageCellEditor from "./ImageCellEditor";
import CommonCellEditor from "./CommonCellEditor";
import TextCellEditor from "./TextCellEditor";
import VideoCellEditor from "./VideoCellEditor";
import ButtonCellEditor from "./ButtonCellEditor";
import EmailFormCellEditor from "./EmailFormCellEditor";
import NeedAdmin from "../../NeedAdmin";
import CarouselCellEditor from "./CarouselCellEditor";
import TabMenuCellEditor from "./TabMenuCellEditor";
import CocaFormCellEditor from "./CocaFormCellEditor";
import ProductsListCellEditor from "./ProductsListCellEditor";
import FormCellEditor from "./FormCellEditor";
import IframeCellEditor from "./IframeCellEditor";
import WheelCellEditor from "./WheelCellEditor"
import Wheel2CellEditor from "./Wheel2CellEditor"
import PlanCellEditor from "./PlanCellEditor";
import ButtonDiffuseCellEditor from "./ButtonDiffuseCellEditor";
import AgendaCellEditor from "./AgendaCellEditor";
import Agendas2CellEditor from "./Agendas2CellEditor";
import AgendaTableauCellEditor from "./AgendaTableauCellEditor";
import Products2CellEditor from "./Products2CellEditor";
import PhotoCellEditor from "./PhotoCellEditor";
import PhotoboothCellEditor from "./PhotoboothCellEditor";
import PhotoboothGifCellEditor from "./PhotoboothGifCellEditor";
import PhotoboothGifCell2Editor from "./PhotoboothGifCell2Editor";
import PhotoboothOBSCellEditor from "./PhotoboothOBSCellEditor";
import PhotoboothLandscapeEditor from "./PhotoboothLandscapeEditor";
import PhotoboothStripePrintCellEditor from "./PhotoboothStripePrintCellEditor";
import ModernPhotoboothCellEditor from "./ModernPhotoboothCellEditor";
import JackpotCellEditor from "./JackpotCellEditor";
import CardsGameEditor from "./CardsGameEditor";
import RankingCellEditor from "./RankingCellEditor";
import PhotoboothChoiceCellEditor from "./PhotoboothChoiceCellEditor";
import PhotoboothCellStatsButton from "../PhotoboothCellStatsButton";
import PhotoboothCellPhotosZipButton from "../PhotoboothCellPhotosZipButton";
import HtmlCellEditor from "./HtmlCellEditor";
import SendEmailCellEditor from "./SendEmailCellEditor";

const ModuleHeader = withRouter(({ cell, onDuplicate, onDelete, match }) => {
  const { projectId, pageId } = match.params;
  const info = CELL_INFO[cell.cell_type];
  return (
    <header className="tsk-module-head">
      <Link to={`/project/${projectId}/page/${pageId}`} className="tsk-module-head__back">{t('ui.module.back')}</Link>
      <h3 className="tsk-module-head__title"><FormattedMessage id={`page.add.cell.button.${cell.cell_type}`} defaultMessage={cell.cell_type} /></h3>
      {info && <p className="tsk-module-head__desc">{info[1]}</p>}
      <div className="tsk-module-head__actions">
        <button type="button" className="tsk-button tsk-small" onClick={() => window.dispatchEvent(new CustomEvent('tsk-open-copy', { detail: { mode: 'cell', id: cell.id, name: '' } }))} title={t('ui.module.copy_title')}>{t('ui.module.copy_to')}</button>
        {onDuplicate && <button type="button" className="tsk-button tsk-small" onClick={onDuplicate} title={t('ui.module.dup_title')}>{t('ui.common.duplicate')}</button>}
        {onDelete && <button type="button" className="tsk-button tsk-small tsk-warning" onClick={onDelete} title={t('ui.module.del_title')}>{t('ui.common.delete')}</button>}
      </div>
    </header>
  );
});

class CellEditor extends React.Component  {

  specificEditor = (cell, language, screenType) => {

    switch (cell.cell_type) {
      case "image":
        return (
          <NeedAdmin>
            <ImageCellEditor cell={cell} language={language} />
          </NeedAdmin>
        );
      case "button_diffuse":
        return (
          <NeedAdmin>
            <ButtonDiffuseCellEditor cell={cell} screenType={screenType} language={language} />
          </NeedAdmin>
        );
      case "text":
        return <TextCellEditor cell={cell} language={language} />;
      case "button":
        return (
          <NeedAdmin>
            <ButtonCellEditor cell={cell} language={language} />
          </NeedAdmin>
        );
      case "video":
        return (
          <NeedAdmin>
            <VideoCellEditor cell={cell} language={language} />
          </NeedAdmin>
        );
      case "form":
        return (
          <NeedAdmin>
            <FormCellEditor cell={cell} language={language} screenType={screenType} />
          </NeedAdmin>
        );
      case "email_form":
        return (
          <NeedAdmin>
            <EmailFormCellEditor cell={cell} language={language} screenType={screenType} />
          </NeedAdmin>
        );
      case "coca_form":
        return (
          <NeedAdmin>
            <CocaFormCellEditor cell={cell} language={language} />
          </NeedAdmin>
        );
      case "carousel":
        return (
          <NeedAdmin>
            <CarouselCellEditor cell={cell} language={language} screenType={screenType}/>
          </NeedAdmin>
        );
      case "tab_menu":
        return (
          <NeedAdmin>
            <TabMenuCellEditor cell={cell} language={language} />
          </NeedAdmin>
        );
      case "products_list":
        return (
          <ProductsListCellEditor cell={cell} />
        );
      case "iframe":
        return (
          <NeedAdmin>
            <IframeCellEditor cell={cell} language={language} screenType={screenType}/>
          </NeedAdmin>
        );
        case"wheel":
      return(
          <NeedAdmin>
            <WheelCellEditor cell={cell} language={language} screenType={screenType}/>
          </NeedAdmin>
        );
        case"wheel2":
          return(
            <NeedAdmin>
              <Wheel2CellEditor cell={cell} language={language} screenType={screenType}/>
            </NeedAdmin>
          );
        case'plan':
          return(
            <NeedAdmin>
              <PlanCellEditor cell={cell} language={language} screenType={screenType}/>
            </NeedAdmin>
        );
        case 'agendas':
          return(
            <NeedAdmin>
              <AgendaCellEditor cell={cell} language={language} screenType={screenType}/>
            </NeedAdmin>
          );
        case 'agendas2':
          return(
            <NeedAdmin>
              <Agendas2CellEditor cell={cell} language={language} screenType={screenType}/>
            </NeedAdmin>
          );
        case 'agenda_tableau':
          return(
            <NeedAdmin>
              <AgendaTableauCellEditor cell={cell} language={language} screenType={screenType}/>
            </NeedAdmin>
          );
        case 'products2':
          return(
            <NeedAdmin>
              <Products2CellEditor cell={cell} language={language} screenType={screenType}/>
            </NeedAdmin>
          );
        case 'photo':
          return(
            <NeedAdmin>
              <PhotoCellEditor cell={cell} language={language} screenType={screenType}/>
            </NeedAdmin>
          );
        case 'photobooth':
          return(
            <NeedAdmin>
              <PhotoboothCellEditor cell={cell} language={language} screenType={screenType}/>
            </NeedAdmin>
          );
        case 'photobooth_gif':
          return(
            <NeedAdmin>
              <PhotoboothGifCellEditor cell={cell} language={language} screenType={screenType}/>
            </NeedAdmin>
          );
        case 'photobooth_gif2':
          return(
            <NeedAdmin>
              <PhotoboothGifCell2Editor cell={cell} language={language} screenType={screenType}/>
            </NeedAdmin>
          );
        case 'photobooth_obs':
          return(
            <NeedAdmin>
              <PhotoboothOBSCellEditor cell={cell} language={language} screenType={screenType}/>
            </NeedAdmin>
          );
        case 'photobooth_landscape':
          return(
            <NeedAdmin>
              <PhotoboothLandscapeEditor cell={cell} language={language} screenType={screenType}/>
            </NeedAdmin>
          );
        case 'photobooth_stripe_print':
          return(
            <NeedAdmin>
              <PhotoboothStripePrintCellEditor cell={cell} language={language} screenType={screenType}/>
            </NeedAdmin>
          );
        case 'modern_photobooth':
          return(
            <NeedAdmin>
              <ModernPhotoboothCellEditor cell={cell} language={language} screenType={screenType}/>
            </NeedAdmin>
          );
      case 'jackpot':
        return (
          <NeedAdmin>
            <JackpotCellEditor cell={cell} language={language} screenType={screenType}/>
          </NeedAdmin>
        );
      case "cards_game":
        return (
          <NeedAdmin>
            <CardsGameEditor cell={cell} language={language} screenType={screenType}/>
          </NeedAdmin>
        );
      case "ranking":
        return (
          <NeedAdmin>
            <RankingCellEditor cell={cell} language={language} screenType={screenType}/>
          </NeedAdmin>
        );
      case "photobooth_choice":
        return (
          <NeedAdmin>
            <PhotoboothChoiceCellEditor cell={cell} language={language} screenType={screenType}/>
          </NeedAdmin>
        );
      case "haribo_photobooth":
        return (
          <NeedAdmin>
            <div>HARIBO Photobooth Configuration</div>
          </NeedAdmin>
        );
      case "johnnie_walker_photobooth":
        return (
          <NeedAdmin>
            <PhotoboothCellStatsButton cell={cell} language={language} screenType={screenType} />
            <PhotoboothCellPhotosZipButton cell={cell} />
          </NeedAdmin>
        );
      case "html":
        return (
          <NeedAdmin>
            <HtmlCellEditor cell={cell} language={language} screenType={screenType}/>
          </NeedAdmin>
        );
      case "send_email":
        return (
          <NeedAdmin>
            <SendEmailCellEditor cell={cell} language={language} screenType={screenType}/>
          </NeedAdmin>
        );
      default:
        return null
    }
  };

  implementsCommon = (cell) => {
    switch (cell.cell_type) {
      case "separator":
      case "language_selection":
      case "tab_menu":
      case "products_list":
      case "memory_game":
      case 'batibouw_finder':
      case 'modern_photobooth':
      case 'jackpot':
      case 'agenda':
      case'plan':
        return false;
      default:
        return true
    }
  };

  render() {
    const { cell, screenType, onDuplicate, onDelete } = this.props;
    if (!cell) return null;
    return (
      <Fragment>
        <ModuleHeader cell={cell} onDuplicate={onDuplicate} onDelete={onDelete} />
        {this.implementsCommon(cell) ? (
          <CommonCellEditor cell={cell} screenType={screenType}>
            {(language) => this.specificEditor(cell, language, screenType)}
          </CommonCellEditor>
        ) : this.specificEditor(cell, null, screenType)}
      </Fragment>
    );

  }
}

export default CellEditor;
